export default "__VITE_ASSET__BQ2pfsLL__"